module.exports = __webpack_public_path__ + "img/marketing.8fe168c8.svg";